export default "/_next/static/fonts/fa1b4853ca1864d57588dcc11cbef6d9.woff2";